<template>
  <div class="selectComp">
    <multiselect
      v-model="value"
      :options="options"
      placeholder="Поиск..."
      :label="label"
      :track-by="label"
      :selectLabel="''"
      :selectedLabel="''"
      :deselectLabel="''"
      :preselect-first="true"
      :allow-empty="false"
      @search-change="searchChange"
    >
      <span slot="noResult">Ничего не найдено</span>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'selectComp',
  props: {
    label: { type: String, default: () => '' },
    options: { type: Array, default: () => [] },
    searchChange: { type: Function, required: false },
    valueChange: { type: Function, required: false }
  },
  data: function () {
    return {
      value: ''
    }
  },
  created: function () {
  },
  mounted () {
  },
  components: {
    Multiselect
  },
  computed: {
  },
  watch: {
    options: function () {
      if (!this.value && this.options.length) this.value = this.options[0]
    },
    value: function () {
      this.valueChange(this.value)
    }
  },
  methods: {
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
</style>
